import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import AddDocumentComponent from '../components/AddDocumentComponent'

const mapStateToProps = (state) => {
  return {
    document: state.document,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDocumentComponent)
